import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/search.svg'


const _hoisted_1 = { class: "hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "searchContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { class: "socialImage" }
const _hoisted_7 = { class: "socialDetails" }
const _hoisted_8 = { class: "fs_14 spaceCadet" }
const _hoisted_9 = { class: "socialSubName" }
const _hoisted_10 = { class: "fs_10 grey" }

export function render(_ctx: any,_cache: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ms-1 me-3 d-flex align-items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncia && _ctx.debouncia(...args))),
          class: "searchInput ms-2",
          ref: "searchInput"
        }, null, 544), [
          [_directive_localizedPlaceholder, { key: 'app_globalSearchText', value: 'Communities, eventi, fiere, brand...' }]
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.results.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 1,
          class: "fs_14 greyBlue d-block ln_12 mt-5 text-center",
          localizedKey: "app_nessunrisultato",
          text: "Nessun risultato"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "socialRow",
        key: item.identifier + item.tag.tag,
        onClick: ($event: any) => (_ctx.openItem(item))
      }, [
        _withDirectives(_createVNode("div", _hoisted_6, null, 512), [
          [_directive_userimage, item.image]
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", {
            class: "fs_14 spaceCadet text-break-word",
            innerHTML: item.name
          }, null, 8, ["innerHTML"]),
          _createVNode("div", _hoisted_8, _toDisplayString(item.isTopic ? ("#" + item.tag.tag) : ""), 1),
          _createVNode("div", _hoisted_9, [
            (item.isTopic)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 0,
                  class: "text-capitalize fs_14 orange",
                  localizedKey: "app_topic",
                  text: "Topic"
                }))
              : (item.isPost)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_localized_text, {
                      class: "text-capitalize fs_14 orange",
                      localizedKey: "app_post",
                      text: "Post"
                    }),
                    _createVNode("span", _hoisted_10, "- " + _toDisplayString(_ctx.$filters.date(item.createdOn, "DD/MM/yyyy")), 1)
                  ], 64))
                : (item.isProduct)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 2,
                      class: "text-capitalize fs_14 orange",
                      localizedKey: "app_prodotto",
                      text: "Prodotto"
                    }))
                  : (item.type == _ctx.community)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 3,
                        class: "text-capitalize fs_14 orange",
                        localizedKey: "app_community",
                        text: "Community"
                      }))
                    : (item.type == _ctx.event)
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 4,
                          class: "text-capitalize fs_14 orange",
                          localizedKey: "app_evento",
                          text: "Evento"
                        }))
                      : (item.type == _ctx.fiera)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 5,
                            class: "text-capitalize fs_14 orange",
                            localizedKey: "app_fiera",
                            text: "Fiera"
                          }))
                        : _createCommentVNode("", true)
          ])
        ])
      ], 8, ["onClick"]))
    }), 128))
  ]))
}